import { PaginationProduct } from "../../generated/graphql";
import { PRODUCT_SUCCESS } from "../action/product.action";

export const ProductActionSuccess = (payload: PaginationProduct) => {
  return {
    type: PRODUCT_SUCCESS,
    payload,
  };
};
